import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/svg/search.svg'
import _imports_1 from '@/assets/svg/cancel.svg'


const _hoisted_1 = ["disabled", "placeholder"]
const _hoisted_2 = {
  key: 0,
  class: "btn-clear ms-rotate-icon",
  "aria-label": "Clear search"
}

import { ref } from 'vue'
import { watchDebounced } from '@vueuse/core'


export default /*@__PURE__*/_defineComponent({
  __name: 'MsSearch',
  props: {
  initialText: {
    type: String,
    required: false
  },
  placeHolder: {
    type: String,
    required: false
  },
  disabled: Boolean
},
  emits: ['update-text'],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

const text = ref(props.initialText || '')

const isActive = ref(!!text.value)

const clearText = () => {
  text.value = ''
  emit('update-text', text.value) // Emit immediately after clearing
  isActive.value = false
}

watchDebounced(
  text,
  (newValue) => {
    if (newValue.length >= 3) {
      emit('update-text', newValue)
      isActive.value = true
    } else {
      emit('update-text', '')
      isActive.value = false
    }
  },
  { debounce: 300 }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["ms-input-textbox", { active: isActive.value }])
    }, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        disabled: __props.disabled,
        placeholder: __props.placeHolder,
        class: "form-control ms-input-text NKT-P2",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((text).value = $event))
      }, null, 8, _hoisted_1), [
        [_vModelText, text.value]
      ]),
      (!isActive.value)
        ? (_openBlock(), _createElementBlock("button", _hoisted_2, _cache[1] || (_cache[1] = [
            _createElementVNode("img", {
              src: _imports_0,
              class: "icon"
            }, null, -1)
          ])))
        : _createCommentVNode("", true),
      (isActive.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "btn-clear ms-rotate-icon",
            onClick: clearText,
            "aria-label": "Clear search"
          }, _cache[2] || (_cache[2] = [
            _createElementVNode("img", {
              src: _imports_1,
              class: "icon"
            }, null, -1)
          ])))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})